var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 124,
    viewBox: "0 0 178 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_994)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 124,
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.9639,
    y: 85.8782,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.80811,
    y: 85.8782,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.1221,
    y: 85.8782,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.28,
    y: 85.8782,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.438,
    y: 85.8782,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.0181,
    y: 14.052,
    width: 109.298,
    height: 62.4561,
    rx: 3.12281,
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid04);
export default __webpack_public_path__ + "static/media/grid_04.c8c21099084365b7ff50aa5396583d39.svg";
export { ForwardRef as ReactComponent };